module.exports = __webpack_public_path__ + "img/Picture3.7e3e4ef6.png";